module.exports = __webpack_public_path__ + "img/Fb.2b55fbfc.svg";